/* Adult competition calendar (sections/ast-comp-calendar.liquid, Oct 22 2026).
   Fetches the events feed (the Apps Script doGet in docs/ast/calendar/competition-calendar-automation.gs) once the
   page has loaded and gone idle, then draws the events in the layout the section picked: agenda, cards or strip.
   Feed shape: { events: [ { id, title, start: "YYYY-MM-DD", end: "YYYY-MM-DD" (last day), location, host, link,
   notes: [""] } ] }. The last good answer is kept in localStorage and drawn at once on the next visit, then refreshed.
   Any failure puts back the section's own fallback (a link to the calendar on Google), never an empty box. */
(function () {
  'use strict';
  var MON = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  var MONTH = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var KEY = 'ast-cc-feed-v1';

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null && text !== '') n.textContent = text;
    return n;
  }
  function parse(d) {
    var p = String(d || '').split('-');
    return p.length === 3 ? { y: +p[0], m: +p[1] - 1, d: +p[2] } : null;
  }
  function ymd(x) { return '' + x.y + (x.m < 9 ? '0' : '') + (x.m + 1) + (x.d < 10 ? '0' : '') + x.d; }
  function nextDay(x) {
    var t = new Date(Date.UTC(x.y, x.m, x.d + 1));
    return { y: t.getUTCFullYear(), m: t.getUTCMonth(), d: t.getUTCDate() };
  }
  function range(a, b) {
    if (!b || (a.y === b.y && a.m === b.m && a.d === b.d)) return MON[a.m] + ' ' + a.d;
    if (a.m === b.m && a.y === b.y) return MON[a.m] + ' ' + a.d + '–' + b.d;
    return MON[a.m] + ' ' + a.d + '–' + MON[b.m] + ' ' + b.d;
  }
  function spoken(a, b) {
    var t = MONTH[a.m] + ' ' + a.d;
    if (b && !(a.y === b.y && a.m === b.m && a.d === b.d)) t += ' to ' + (b.m === a.m ? '' : MONTH[b.m] + ' ') + b.d;
    return t + ', ' + (b || a).y;
  }
  function today() {
    var t = new Date();
    return t.getFullYear() * 10000 + (t.getMonth() + 1) * 100 + t.getDate();
  }

  function prepare(list) {
    var now = today();
    return (list || []).map(function (e) {
      var a = parse(e.start), b = parse(e.end) || a;
      if (!a || !e.title) return null;
      return { e: e, a: a, b: b };
    }).filter(function (x) {
      return x && +ymd(x.b) >= now;
    }).sort(function (x, y) { return ymd(x.a) - ymd(y.a) || String(x.e.title).localeCompare(y.e.title); });
  }

  function link(href, text, newTab, cls) {
    var a = el('a', cls || 'link', text);
    a.href = href;
    a.target = '_blank';
    a.rel = 'noopener';
    if (newTab) a.appendChild(el('span', 'visually-hidden', ' ' + newTab));
    return a;
  }
  function gcal(x, tz) {
    var e = x.e;
    var q = 'action=TEMPLATE&text=' + encodeURIComponent(e.title) + '&dates=' + ymd(x.a) + '/' + ymd(nextDay(x.b)) +
      (e.location ? '&location=' + encodeURIComponent(e.location) : '') + (tz ? '&ctz=' + encodeURIComponent(tz) : '') +
      (e.link ? '&details=' + encodeURIComponent(e.link) : '');
    return 'https://calendar.google.com/calendar/render?' + q;
  }
  function meta(x, L) {
    var f = document.createDocumentFragment(), e = x.e;
    if (e.location) f.appendChild(el('p', 'ast-cc-ev__m', e.location));
    if (e.host) {
      var h = el('p', 'ast-cc-ev__m');
      h.appendChild(el('span', '', L.host + ' '));
      h.appendChild(document.createTextNode(e.host));
      f.appendChild(h);
    }
    (e.notes || []).forEach(function (n) { if (n) f.appendChild(el('p', 'ast-cc-ev__m', n)); });
    return f;
  }
  function acts(x, L) {
    var ul = el('ul', 'ast-cc-ev__acts');
    ul.setAttribute('role', 'list');
    var li = el('li');
    // S16 (site audit Oct 24, Erika said yes Oct 25): a button pair, the main action in the primary gradient and the
    // official page in the ink outline, so the two never look the same.
    li.appendChild(link(gcal(x, L.tz), L.add, L.newTab, 'btn btn--primary'));
    ul.appendChild(li);
    if (x.e.link && /^https?:\/\//i.test(x.e.link)) {
      li = el('li');
      li.appendChild(link(x.e.link, L.link, L.newTab, 'btn btn--secondary'));
      ul.appendChild(li);
    }
    return ul;
  }
  // Month anchors: readable ids ("nov-2026") so a jump leaves a hash that can be shared.
  function mid(y, m) { return MON[m].toLowerCase() + '-' + y; }
  function monthId(root, x) { return mid(x.a.y, x.a.m); }
  function monthHead(tag, x) {
    var h = el(tag, 'ast-cc-mon', MONTH[x.a.m] + ' ' + x.a.y);
    h.id = mid(x.a.y, x.a.m);
    h.tabIndex = -1;
    return h;
  }
  function groups(items) {
    var out = [], cur = null;
    items.forEach(function (x) {
      var k = x.a.y + '-' + x.a.m;
      if (!cur || cur.k !== k) { cur = { k: k, y: x.a.y, m: x.a.m, items: [] }; out.push(cur); }
      cur.items.push(x);
    });
    return out;
  }
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  // One jump for every layout: scroll to the month (smooth, instant with reduced motion; the target's scroll-margin
  // clears the sticky header), move keyboard focus to it, and leave its hash in the address bar.
  function jump(id, smooth) {
    var t = document.getElementById(id);
    if (!t) return false;
    // The picked month: the month row's link to it carries aria-current, which the section's CSS marks with the 2px
    // state line; the one picked before lets go of it.
    var root = t.closest('[data-ast-cc]');
    if (root) root.querySelectorAll('.ast-cc__months a, .ast-cc__strip a').forEach(function (a) {
      if (a.getAttribute('href') === '#' + id) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
    t.scrollIntoView({ behavior: smooth && !reduced() ? 'smooth' : 'auto', block: 'start' });
    try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); }
    if (location.hash !== '#' + id && history.replaceState) history.replaceState(null, '', '#' + id);
    return true;
  }
  // The month row. Agenda and cards: one link per month that has events, in date order, with the year shown where the
  // row crosses into a new year. Strip: the whole season month by month, empty months greyed, with event counts.
  function months(root, items, view) {
    var nav = el('nav', view === 'strip' ? 'ast-cc__strip' : 'ast-cc__months');
    nav.setAttribute('aria-label', root.dataset.monthsLabel || 'Months');
    var gs = groups(items), count = {};
    gs.forEach(function (g) { count[g.k] = g.items.length; });
    if (view === 'strip') {
      var a = items[0].a, z = items[items.length - 1].a, y = a.y, m = a.m, n = 0;
      while ((y < z.y || (y === z.y && m <= z.m)) && n < 24) {
        var c = count[y + '-' + m] || 0;
        var cell = el(c ? 'a' : 'span');
        if (c) {
          cell.href = '#' + mid(y, m);
          cell.setAttribute('aria-label', MONTH[m] + ' ' + y + ', ' + c + (c === 1 ? ' event' : ' events'));
        } else {
          cell.setAttribute('aria-hidden', 'true');
        }
        cell.appendChild(el('b', '', MON[m]));
        cell.appendChild(el('i', '', c ? String(c) : '·'));
        nav.appendChild(cell);
        m += 1; n += 1;
        if (m > 11) { m = 0; y += 1; }
      }
    } else {
      var ul = el('ul');
      ul.setAttribute('role', 'list');
      var lastY = gs.length ? gs[0].y : 0;
      gs.forEach(function (g) {
        var li = el('li'), link = el('a');
        link.href = '#' + mid(g.y, g.m);
        var words = el('span', 'ast-u', MONTH[g.m].slice(0, 3));
        link.appendChild(words);
        // The year is always in the link's name ("Nov 2026"), and shown where the row crosses into a new year.
        if (g.y !== lastY) { link.appendChild(el('span', 'ast-cc__yr', ' ' + g.y)); lastY = g.y; }
        else link.appendChild(el('span', 'visually-hidden', ' ' + g.y));
        li.appendChild(link);
        ul.appendChild(li);
      });
      nav.appendChild(ul);
    }
    // A month row wider than the screen fades out at the edge that has more months past it, so it reads as a row that
    // scrolls sideways (layout audit L14, Oct 23 2026: at 390 it was cut at "JU" with nothing to say there was more).
    if (view !== 'strip') {
      var edges = function () {
        var max = nav.scrollWidth - nav.clientWidth;
        nav.classList.toggle('is-more-right', max > 1 && nav.scrollLeft < max - 1);
        nav.classList.toggle('is-more-left', max > 1 && nav.scrollLeft > 1);
      };
      nav.addEventListener('scroll', edges, { passive: true });
      window.addEventListener('resize', edges);
      requestAnimationFrame(edges);
    }
    nav.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('a[href^="#"]');
      if (!a) return;
      if (jump(a.getAttribute('href').slice(1), true)) ev.preventDefault();
    });
    return nav;
  }

  function agenda(root, items, L) {
    var f = document.createDocumentFragment(), cur = '';
    items.forEach(function (x) {
      var k = x.a.y + '-' + x.a.m;
      if (k !== cur) {
        f.appendChild(monthHead('h3', x));
        cur = k;
      }
      var row = el('article', 'ast-cc-ag');
      var db = el('div', 'ast-cc-db');
      db.setAttribute('aria-hidden', 'true');
      db.appendChild(el('span', 'ast-cc-db__m', MON[x.a.m]));
      db.appendChild(el('span', 'ast-cc-db__n', String(x.a.d)));
      var same = x.a.y === x.b.y && x.a.m === x.b.m && x.a.d === x.b.d;
      if (!same) db.appendChild(el('span', 'ast-cc-db__r', 'to ' + (x.b.m === x.a.m ? '' : MON[x.b.m] + ' ') + x.b.d));
      var body = el('div');
      body.appendChild(el('h4', 'ast-cc-ev__t', x.e.title));
      body.appendChild(el('p', 'visually-hidden', spoken(x.a, x.b)));
      body.appendChild(meta(x, L));
      body.appendChild(acts(x, L));
      row.appendChild(db);
      row.appendChild(body);
      f.appendChild(row);
    });
    return f;
  }
  function cards(root, items, L) {
    var f = document.createDocumentFragment();
    groups(items).forEach(function (g) {
      f.appendChild(monthHead('h3', g.items[0]));
      var ul = el('ul', 'ast-cc-cards');
      ul.setAttribute('role', 'list');
      g.items.forEach(function (x) {
        var li = el('li', 'ast-cc-card');
        li.appendChild(el('p', 'ast-cc-card__when', range(x.a, x.b) + ', ' + x.a.y));
        li.appendChild(el('h4', 'ast-cc-ev__t', x.e.title));
        li.appendChild(meta(x, L));
        li.appendChild(acts(x, L));
        ul.appendChild(li);
      });
      f.appendChild(ul);
    });
    return f;
  }
  function strip(root, items, L) {
    var ul = el('ul', 'ast-cc-tl');
    ul.setAttribute('role', 'list');
    var seen = {};
    items.forEach(function (x) {
      var li = el('li');
      var k = x.a.y + '-' + x.a.m;
      if (!seen[k]) { li.id = monthId(root, x); li.tabIndex = -1; seen[k] = 0; }
      seen[k] += 1;
      li.appendChild(el('p', 'ast-cc-tl__d', range(x.a, x.b)));
      var body = el('div');
      body.appendChild(el('h3', 'ast-cc-ev__t', x.e.title));
      body.appendChild(el('p', 'visually-hidden', ', ' + x.a.y));
      body.appendChild(meta(x, L));
      li.appendChild(body);
      li.appendChild(acts(x, L));
      ul.appendChild(li);
    });
    return ul;
  }

  function draw(root, data) {
    var box = root.querySelector('[data-ast-cc-events]');
    if (!box) return false;
    var L = {
      add: root.dataset.addLabel || 'Add to my calendar',
      link: root.dataset.linkLabel || 'Official announcement',
      host: root.dataset.hostLabel || 'Host:',
      newTab: root.dataset.newTab || '',
      tz: (data && data.timezone) || ''
    };
    var items = prepare(data && data.events);
    var view = root.dataset.view;
    box.textContent = '';
    box.classList.toggle('is-fallback', !items.length);
    if (!items.length) {
      box.appendChild(el('p', 'ast-cc__fallback', root.dataset.empty || ''));
    } else {
      // The month row goes inside the events box, so the height the box holds while the feed loads covers it too.
      box.appendChild(months(root, items, view));
      box.appendChild(view === 'cards' ? cards(root, items, L) : view === 'strip' ? strip(root, items, L) : agenda(root, items, L));
    }
    box.setAttribute('aria-busy', 'false');
    // A shared link (#nov-2026) lands before the events exist; go to it once they are drawn.
    var h = decodeURIComponent((location.hash || '').slice(1));
    if (h && !root.dataset.jumped && box.querySelector('[id="' + h.replace(/"/g, '') + '"]')) { root.dataset.jumped = '1'; jump(h, false); }
    return true;
  }
  function fallback(root) {
    var box = root.querySelector('[data-ast-cc-events]');
    var tpl = root.querySelector('template[data-ast-cc-fallback]');
    if (!box || !tpl) return;
    box.textContent = '';
    box.classList.add('is-fallback');
    box.appendChild(tpl.content.cloneNode(true));
    box.setAttribute('aria-busy', 'false');
  }
  function cached() {
    try { var v = localStorage.getItem(KEY); return v ? JSON.parse(v) : null; } catch (e) { return null; }
  }
  function store(data) {
    try { localStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
  }

  function start(root) {
    var url = root.dataset.feed;
    if (!url) return;
    var drawn = false;
    var old = cached();
    if (old && old.events) drawn = draw(root, old);
    // A feed that hangs gives way to the fallback after 10s instead of leaving "Loading" up for good.
    var ctl = 'AbortController' in window ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); if (!drawn) fallback(root); }, 10000);
    fetch(url, { credentials: 'omit', signal: ctl ? ctl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (data) {
        if (!data || !Array.isArray(data.events)) throw new Error('shape');
        clearTimeout(timer);
        store(data);
        drawn = draw(root, data);
      })
      .catch(function () { clearTimeout(timer); if (!drawn) fallback(root); });
  }
  function boot() {
    var roots = document.querySelectorAll('[data-ast-cc][data-feed]');
    for (var i = 0; i < roots.length; i++) start(roots[i]);
  }
  function later() {
    if ('requestIdleCallback' in window) window.requestIdleCallback(boot, { timeout: 2000 });
    else setTimeout(boot, 200);
  }
  if (document.readyState === 'complete') later();
  else window.addEventListener('load', later, { once: true });
  // Theme editor: this file loads as a module, which runs once per page, so a section the editor reloads is drawn
  // here rather than by running the file again (rebuild stage 1, expert gate finding 3).
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelectorAll('[data-ast-cc][data-feed]');
    for (var i = 0; i < r.length; i++) start(r[i]);
  });
})();
